import React, { useMemo, useState } from 'react'

import { useDebounce } from 'hooks/useDebounce'

import { TemplatesContext } from './TemplatesContext'
import { TemplatesContextControllerProps } from './TemplatesContextController.types'
import { TemplateFilterOption } from './TemplatesContext.types'

export const TemplatesContextController = ({ children }: TemplatesContextControllerProps) => {
    const [searchValue, setSearchValue] = useState('')
    const [selectedTemplateTypes, setSelectedTemplateTypes] = useState<TemplateFilterOption[]>([])
    const debouncedSearchValue = useDebounce(searchValue, 500)

    const handleChangeSearchValue = (searchValue: string) => {
        setSearchValue(searchValue)
    }

    const handleChangeSelectedTemplateTypes = (selectedTemplateTypes: TemplateFilterOption[]) => {
        setSelectedTemplateTypes(selectedTemplateTypes)
    }

    const contextValue = useMemo(
        () => ({
            searchValue,
            debouncedSearchValue: debouncedSearchValue,
            onChangeSearchValue: handleChangeSearchValue,
            selectedTemplateTypes,
            onChangeSelectedTemplateTypes: handleChangeSelectedTemplateTypes,
        }),
        [debouncedSearchValue, searchValue, selectedTemplateTypes],
    )

    return <TemplatesContext.Provider value={contextValue}>{children}</TemplatesContext.Provider>
}
